var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c('pre',{staticClass:"bg-red p-1 bg-opacity-40"},[_vm._v("    "),_vm._t("default"),_vm._v("\n  ")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }